import { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { History, ArrowRight, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

export default function ChangesPage() {
  const { authAxios } = useAuth();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const api = authAxios();
      const res = await api.get('/changes');
      setEvents(res.data);
    } catch (err) {
      toast.error('Failed to fetch changes');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[60vh]">
        <RefreshCw className="w-8 h-8 text-[#EF694C] animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl md:text-4xl font-bold font-heading text-white tracking-tight">
          History Feed
        </h1>
        <p className="text-sm text-[#a1a1aa] mt-1">
          Recent infrastructure changes and regressions
        </p>
      </div>

      <div className="space-y-4">
        {events.map((evt, i) => (
          <Card key={i} className="bg-[#121214] border-white/10">
            <CardContent className="p-4">
              <div className="flex items-start gap-4">
                <div className="mt-1">
                  <Badge variant="outline" className={`border-white/10 ${
                    evt.severity === 'high' ? 'text-red-500 bg-red-500/10' : 'text-blue-500 bg-blue-500/10'
                  }`}>
                    {evt.event_type}
                  </Badge>
                </div>
                <div className="flex-1">
                  <div className="flex justify-between">
                    <span className="font-mono text-white text-sm">{evt.fqdn}</span>
                    <span className="text-xs text-[#52525b]">{new Date(evt.ts).toLocaleString()}</span>
                  </div>
                  
                  <div className="mt-2 flex items-center gap-2 text-sm text-[#a1a1aa] bg-black/20 p-2 rounded font-mono overflow-x-auto">
                    <span className="text-red-400">{JSON.stringify(evt.before)}</span>
                    <ArrowRight className="w-4 h-4 text-[#52525b]" />
                    <span className="text-emerald-400">{JSON.stringify(evt.after)}</span>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
        {events.length === 0 && (
          <div className="text-center py-12 text-[#52525b]">
            <History className="w-12 h-12 mx-auto mb-3 opacity-20" />
            <p>No history recorded yet</p>
          </div>
        )}
      </div>
    </div>
  );
}
